import React from "react";

import ViewerStyle from '../../css/Viewer.module.css';

// A button that opens a group of viewers rather than one viewer: a soft
// background, how many viewers it holds and a chevron, so it does not read
// as one more month (the owner's request of 2026-10-13). Its icon says what
// it holds: the albums by default, the chart for the Datos Canales.
export default function GroupButton(props) {
    const { label, count, onClick, active, icon = 'albums-outline' } = props;
    return (
        <div className={`${ViewerStyle["btn-month"]} ${ViewerStyle["btn-group"]}${active ? ` ${ViewerStyle["active"]}` : ''}`} onClick={onClick} title={label}>
            <ion-icon name={icon} />
            <span>
                {`${label} (${count})`}
                <ion-icon name="chevron-forward-outline" />
            </span>
        </div>
    );
}
